import { getCloudinaryFullPath } from "../../utils";

// Shared with Royal Mahal: names from the invite URL and the Jain check.
export { coupleNames, isJainInvite } from "../RoyalMahal/helpers";

/*
 * The hero illustration dropped into src/images/rang-utsav is picked up automatically
 * (see the README there); a missing one gives null. Only hero-illustration.* is matched,
 * so the folder's other images aren't pulled into the build. When the compressed WebP
 * sits beside the original PNG, the WebP is the one used.
 */
const context = require.context("../../images/rang-utsav", false, /^\.\/hero-illustration\.(webp|jpe?g|png)$/i);
const heroFile = ["webp", "png", "jpg", "jpeg"]
  .map((ext) => context.keys().find((key) => key.toLowerCase() === `./hero-illustration.${ext}`))
  .find(Boolean);
const HERO_ILLUSTRATION = heroFile ? context(heroFile) : null;

const fullUrl = (path) => (/^(https?:)?\/\/|^data:|^blob:/.test(path) ? path : getCloudinaryFullPath(path));

/**
 * The illustration under the first page's flower arch: the invite's own `heroIllustration`
 * when it has one, otherwise src/images/rang-utsav/hero-illustration.*, otherwise null.
 */
export const heroIllustration = (invite) => {
  const own = invite?.heroIllustration;
  if (typeof own === "string" && own.trim()) return fullUrl(own.trim());
  return HERO_ILLUSTRATION;
};
